import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  isLoading?: boolean;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  isLoading = false,
  fullWidth = false,
  className = '',
  disabled,
  type = 'button',
  ...props
}: ButtonProps) {
  // min-h-[44px] ensures WCAG 2.5.5 / 2.5.8 touch target (44x44).
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-medium transition-all min-h-[44px] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm px-5 py-3';
  const variants = {
    primary: 'bg-[#FFCC00] text-black hover:bg-[#E6B800] focus-visible:ring-black shadow-sm font-semibold',
    secondary: 'bg-black text-white hover:bg-gray-800 focus-visible:ring-black shadow-sm font-semibold',
    outline: 'border-2 border-gray-900 bg-white text-gray-900 hover:bg-gray-50 focus-visible:ring-black font-semibold',
    ghost: 'text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus-visible:ring-black'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button type={type} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} disabled={disabled || isLoading} aria-busy={isLoading || undefined} {...props} data-id="element-946">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" data-id="element-947" />}
      {children}
    </button>;
}